import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, Checkbox, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";

import { SelectOptionsHelper } from '../../../helpers/SelectOptionsHelper';

export class EventForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            event: props.event,
            eventTypeInputError: null,
            nameInputError: null,
            beginDateInputError: null,
            endDateInputError: null,
            nrConsecutiveDaysInputError: null,
            conditionInputError: null,
            dayOfWeekInputError: null,
            dayOfMonthInputError: null,
            weeksInputError: null,
            dayInputError: null,
            monthInputError: null
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { event } = this.state;

        event[property] = e.target.value;

        this.setState({
            event: event
        });
    }

    onChangeDateValue(e, property) {
        const { event } = this.state;

        if (null === e || undefined === e) {
            event[property] = undefined;
        }
        else {
            event[property] = e.split("T")[0];
        }

        this.setState({
            event: event
        });
    }

    onChangeCheckboxValue(e, property) {
        const { event } = this.state;

        event[property] = e.target.checked;

        this.setState({
            event: event
        });
    }

    onChangeCheckboxValueToArray(e, property, value) {
        const { event } = this.state;
        const includesValues = undefined === event[property] ? false : event[property].includes(value);

        if (e.target.checked && !includesValues) {
            if (undefined === event[property]) {
                event[property] = [];
            }
            event[property].push(value);
        }
        else if (!e.target.checked) {
            event[property] = event[property].filter(x => x !== value);
        }

        this.setState({
            event: event
        });
    }

    onSelectValueId(e, property) {
        const { event } = this.state;

        if (null === e || undefined === e) {
            event[property] = undefined;
        }
        else {
            event[property] = e.id;
        }

        this.setState({
            event: event
        });
    }

    onSave() {
        if (this.validInput()) {
            const { event } = this.state;
            this.props.onSave(event);
        }
    }

    validRecurrentWeeklyEvent(event) {
        if ("recurrent-weekly" !== event.type) {
            return true;
        }

        let errors = 0;
        let dayOfWeekInputError = null;

        if ("" === event.dayOfWeek || null === event.dayOfWeek || undefined === event.dayOfWeek) {
            dayOfWeekInputError = 'error';
            errors++;
        }

        this.setState({
            dayOfWeekInputError: dayOfWeekInputError,
        });

        return errors > 0 ? false : true;
    }

    validRecurrentMonthlyEvent(event) {
        if ("recurrent-monthly" !== event.type) {
            return true;
        }

        let errors = 0;
        let dayOfMonthInputError = null;
        let dayOfWeekInputError = null;
        let weeksInputError = null;

        if (event.useDayOfMonth) {
            if ("" === event.dayOfMonth || null === event.dayOfMonth || undefined === event.dayOfMonth || 0 >= event.dayOfMonth || 31 < event.dayOfMonth) {
                dayOfMonthInputError = 'error';
                errors++;
            }
        }
        else {
            if ("" === event.dayOfWeek || null === event.dayOfWeek || undefined === event.dayOfWeek) {
                dayOfWeekInputError = 'error';
                errors++;
            }

            if(undefined === event.weeks || null === event.weeks || 0 === event.weeks.length) {
                weeksInputError = 'error';
                errors++;
            }
        }

        this.setState({
            dayOfMonthInputError: dayOfMonthInputError,
            dayOfWeekInputError: dayOfWeekInputError,
            weeksInputError: weeksInputError,
        });

        return errors > 0 ? false : true;
    }

    validRecurrentYearlyEvent(event) {
        if ("recurrent-yearly" !== event.type) {
            return true;
        }

        let errors = 0;
        let dayInputError = null;
        let monthInputError = null;

        let month = event.month;
        if ("" === event.month || null === event.month || undefined === event.month) {
            month = 1;
            monthInputError = 'error';
            errors++;
        }

        if ("" === event.day || null === event.day || undefined === event.day || 0 >= event.day || new Date(2020, month, 0).getDate() < event.day) {
            dayInputError = 'error';
            errors++;
        }

        this.setState({
            dayInputError: dayInputError,
            monthInputError: monthInputError,
        });

        return errors > 0 ? false : true;
    }

    validRecurrentEventInput(event) {
        if ("recurrent" !== event.type && "recurrent-weekly" !== event.type && "recurrent-monthly" !== event.type && "recurrent-yearly" !== event.type) {
            return true;
        }

        let errors = 0;
        let conditionInputError = null;
        let nrConsecutiveDaysInputError = null;

        if ("" === event.nrConsecutiveDays || null === event.nrConsecutiveDays || undefined === event.nrConsecutiveDays || 0 >= event.nrConsecutiveDays) {
            nrConsecutiveDaysInputError = 'error';
            errors++;
        }

        if ("" !== event.specialConditionDayOfWeek && null !== event.specialConditionDayOfWeek && undefined !== event.specialConditionDayOfWeek &&
            ("" === event.specialConditionDayType || null === event.specialConditionDayType || undefined === event.specialConditionDayType)) {
            conditionInputError = 'error';
            errors++;
        }

        if ("" !== event.specialConditionDayType && null !== event.specialConditionDayType && undefined !== event.specialConditionDayType &&
            ("" === event.specialConditionDayOfWeek || null === event.specialConditionDayOfWeek || undefined === event.specialConditionDayOfWeek)) {
            conditionInputError = 'error';
            errors++;
        }

        if (!this.validRecurrentWeeklyEvent(event)) {
            errors++;
        }

        if (!this.validRecurrentMonthlyEvent(event)) {
            errors++;
        }

        if (!this.validRecurrentYearlyEvent(event)) {
            errors++;
        }

        this.setState({
            nrConsecutiveDaysInputError: nrConsecutiveDaysInputError,
            conditionInputError: conditionInputError,
        });

        return errors > 0 ? false : true;
    }

    validUniqueEventInput(event) {
        if ("unique" !== event.type) {
            return true;
        }

        let errors = 0;
        let beginDateInputError = null;
        let endDateInputError = null;

        if ("" === event.beginDate || null === event.beginDate || undefined === event.beginDate) {
            beginDateInputError = 'error';
            errors++;
        }

        if ("" === event.endDate || null === event.endDate || undefined === event.endDate || event.endDate < event.beginDate) {
            endDateInputError = 'error';
            errors++;
        }

        this.setState({
            beginDateInputError: beginDateInputError,
            endDateInputError: endDateInputError,
        });

        return errors > 0 ? false : true;
    }

    validInput() {
        let errors = 0;
        let eventTypeInputError = null;
        let nameInputError = null;

        const { event } = this.state;

        if ("" === event.type || null === event.type || undefined === event.type) {
            eventTypeInputError = 'error';
            errors++;
        }

        if ("" === event.name || null === event.name || undefined === event.name) {
            nameInputError = 'error';
            errors++;
        }

        if (!this.validUniqueEventInput(event)) {
            errors++;
        }

        if (!this.validRecurrentEventInput(event)) {
            errors++;
        }

        this.setState({
            eventTypeInputError: eventTypeInputError,
            nameInputError: nameInputError
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    renderUniqueEventForm(event) {
        if ("unique" === event.type) {
            const { beginDateInputError, endDateInputError } = this.state;

            return (
                <div>
                    <FormGroup controlId="formBeginDate" validationState={beginDateInputError}>
                        <ControlLabel>Data de Início</ControlLabel>
                        <DatePicker
                            id="beginDatePicker"
                            dateFormat="YYYY/MM/DD"
                            value={event.beginDate}
                            placeholder="Introduza a Data de Início"
                            onChange={(e) => this.onChangeDateValue(e, 'beginDate')} />

                        {beginDateInputError !== null ?
                            <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock> :
                            null
                        }
                    </FormGroup>

                    <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                        <ControlLabel>Data de Fim</ControlLabel>
                        <DatePicker
                            id="endDatePicker"
                            dateFormat="YYYY/MM/DD"
                            value={event.endDate}
                            placeholder="Introduza a Data de Fim"
                            onChange={(e) => this.onChangeDateValue(e, 'endDate')} />

                        {endDateInputError !== null ?
                            <HelpBlock> Valor de data inválido. Verifique que a data não é anterior à data inicial e que não está vazia. </HelpBlock> :
                            null
                        }
                    </FormGroup>
                </div>
            );
        }

        return null;
    }

    renderWeeklyEventProperties(event) {
        if ("recurrent-weekly" === event.type) {
            const { dayOfWeekInputError } = this.state;

            return (
                <FormGroup controlId="formDayOfWeek" validationState={dayOfWeekInputError}>
                    <ControlLabel>Dia da Semana</ControlLabel>
                    <Select
                        className="custom-multiselect"
                        placeholder="Sem Dia da Semana"
                        noOptionsMessage={() => "Sem Dias da Semana Configurados"}
                        onChange={(e) => this.onSelectValueId(e, "dayOfWeek")}
                        options={SelectOptionsHelper.WeekDays}
                        isMulti={false}
                        isClearable={true}
                        isOptionSelected={function (a) {
                            if (null !== event.dayOfWeek && undefined !== event.dayOfWeek) {
                                return event.dayOfWeek === a.id;
                            }
                        }}
                        getOptionValue={value => value.id}
                        getOptionLabel={label => label.label}
                        value={SelectOptionsHelper.WeekDays.find(x => x.id === event.dayOfWeek)}
                    />
                    {dayOfWeekInputError !== null ?
                        <HelpBlock> O campo não pode estar vazio </HelpBlock> :
                        null
                    }
                </FormGroup>
            );
        }

        return null;
    }

    renderMonthlyEventProperties(event) {
        if ("recurrent-monthly" === event.type) {
            let formElements;

            if (event.useDayOfMonth) {
                const { dayOfMonthInputError } = this.state;

                formElements = (
                    <FormGroup controlId="formDayOfMonth" validationState={dayOfMonthInputError}>
                        <ControlLabel>Dia do Mês</ControlLabel>
                        <FormControl
                            type="number"
                            min="1"
                            max="31"
                            value={undefined === event.dayOfMonth ? "" : event.dayOfMonth}
                            placeholder="Dia do Mês"
                            onChange={(e) => this.onChangeValue(e, 'dayOfMonth')}
                        />
                        {dayOfMonthInputError !== null ?
                            <HelpBlock> O campo não pode estar vazio e tem de estar entre 1 e 31 </HelpBlock> :
                            null
                        }
                    </FormGroup>
                );
            }
            else {
                const { dayOfWeekInputError, weeksInputError } = this.state;

                formElements = (
                    <div>
                        <FormGroup controlId="formDayOfWeek" validationState={dayOfWeekInputError}>
                            <ControlLabel>Dia da Semana</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Dia da Semana"
                                noOptionsMessage={() => "Sem Dias da Semana Configurados"}
                                onChange={(e) => this.onSelectValueId(e, "dayOfWeek")}
                                options={SelectOptionsHelper.WeekDays}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== event.dayOfWeek && undefined !== event.dayOfWeek) {
                                        return event.dayOfWeek === a.id;
                                    }
                                }}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.label}
                                value={SelectOptionsHelper.WeekDays.find(x => x.id === event.dayOfWeek)}
                            />
                            {dayOfWeekInputError !== null ?
                                <HelpBlock> O campo não pode estar vazio </HelpBlock> :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formWeeks" validationState={weeksInputError}>
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={undefined === event.weeks ? false : event.weeks.includes(1)}
                                onChange={(e) => this.onChangeCheckboxValueToArray(e, "weeks", 1)}>
                                Semana 1
                            </Checkbox>
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={undefined === event.weeks ? false : event.weeks.includes(2)}
                                onChange={(e) => this.onChangeCheckboxValueToArray(e, "weeks", 2)}>
                                Semana 2
                            </Checkbox>
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={undefined === event.weeks ? false : event.weeks.includes(3)}
                                onChange={(e) => this.onChangeCheckboxValueToArray(e, "weeks", 3)}>
                                Semana 3
                            </Checkbox>
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={undefined === event.weeks ? false : event.weeks.includes(4)}
                                onChange={(e) => this.onChangeCheckboxValueToArray(e, "weeks", 4)}>
                                Semana 4
                            </Checkbox>
                            {weeksInputError !== null ?
                                <HelpBlock> Tem de selecionar pelo menos 1 semana do mês </HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </div>
                );
            }

            return (
                <div>
                    <FormGroup controlId="formUseDayOfMonth">
                        <Checkbox
                            className="form-checkbox"
                            defaultChecked={event.useDayOfMonth}
                            onChange={(e) => this.onChangeCheckboxValue(e, "useDayOfMonth")}>
                            Usar Dia do Mês
                        </Checkbox>
                    </FormGroup>
                    {formElements}
                </div>
            )
        }

        return null;
    }

    renderYearlyEventProperties(event) {
        if ("recurrent-yearly" === event.type) {
            const { dayInputError, monthInputError } = this.state;

            return (
                <div>
                    <FormGroup controlId="formDay" validationState={dayInputError}>
                        <ControlLabel>Dia</ControlLabel>
                        <FormControl
                            type="number"
                            min="1"
                            value={undefined === event.day ? "" : event.day}
                            placeholder="Dia"
                            onChange={(e) => this.onChangeValue(e, 'day')}
                        />
                        {dayInputError !== null ?
                            <HelpBlock> O campo não pode estar vazio e tem de estar entre 1 e 31 (dependendo do mês selecionado) </HelpBlock> :
                            null
                        }
                    </FormGroup>
                    <FormGroup controlId="formException" validationState={monthInputError}>
                        <ControlLabel>Mês</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem Mês"
                            noOptionsMessage={() => "Sem Meses Configurados"}
                            onChange={(e) => this.onSelectValueId(e, "month")}
                            options={SelectOptionsHelper.Months}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                if (null !== event.month && undefined !== event.month) {
                                    return event.month === a.id;
                                }
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.label}
                            value={SelectOptionsHelper.Months.find(x => x.id === event.month)}
                        />
                        {monthInputError !== null ?
                            <HelpBlock> O campo não pode estar vazio </HelpBlock> :
                            null
                        }
                    </FormGroup>
                </div>
            );
        }

        return null;
    }

    renderRecurrentEventForm(event) {
        if ("recurent" === event.type || "recurrent-weekly" === event.type || "recurrent-monthly" === event.type || "recurrent-yearly" === event.type) {
            const { nrConsecutiveDaysInputError, conditionInputError } = this.state;
            const { dayTypes } = this.props;

            return (
                <div>
                    {this.renderWeeklyEventProperties(event)}
                    {this.renderMonthlyEventProperties(event)}
                    {this.renderYearlyEventProperties(event)}

                    <FormGroup controlId="fromNrConsecutiveDays" validationState={nrConsecutiveDaysInputError}>
                        <ControlLabel>Nr. de Dias</ControlLabel>
                        <FormControl
                            type="number"
                            min="1"
                            value={undefined === event.nrConsecutiveDays ? "" : event.nrConsecutiveDays}
                            placeholder="Introduza o Nr de Dias consecutivos que ocorre o Evento"
                            onChange={(e) => this.onChangeValue(e, 'nrConsecutiveDays')}
                        />
                        {nrConsecutiveDaysInputError !== null ?
                            <HelpBlock> O campo não pode estar vazio e tem de ter um valor igual ou superior a 1 </HelpBlock> :
                            null
                        }
                    </FormGroup>

                    <FormGroup controlId="formCondition" validationState={conditionInputError}>
                        <ControlLabel>Condição</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem Dia da Semana"
                            noOptionsMessage={() => "Sem Dias da Semana Configurados"}
                            onChange={(e) => this.onSelectValueId(e, "specialConditionDayOfWeek")}
                            options={SelectOptionsHelper.WeekDays}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                if (null !== event.specialConditionDayOfWeek && undefined !== event.specialConditionDayOfWeek) {
                                    return event.specialConditionDayOfWeek === a.id;
                                }
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.label}
                            value={SelectOptionsHelper.WeekDays.find(x => x.id === event.specialConditionDayOfWeek)}
                        />
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem Tipo de Dia"
                            noOptionsMessage={() => "Sem Tipos de Dia Configurados"}
                            onChange={(e) => this.onSelectValueId(e, "specialConditionDayType")}
                            options={dayTypes}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                if (null !== event.specialConditionDayType && undefined !== event.specialConditionDayType) {
                                    return event.specialConditionDayType === a.id;
                                }
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.name}
                            value={dayTypes.find(x => x.id === event.specialConditionDayType)}
                        />
                        {conditionInputError !== null ?
                            <HelpBlock> Condição Inválida </HelpBlock> :
                            null
                        }
                    </FormGroup>

                    <FormGroup controlId="formException">
                        <ControlLabel>Exceção</ControlLabel>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem Tipo de Dia"
                            noOptionsMessage={() => "Sem Tipos de Dia Configurados"}
                            onChange={(e) => this.onSelectValueId(e, "exceptionDayType")}
                            options={dayTypes}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                if (null !== event.exceptionDayType && undefined !== event.exceptionDayType) {
                                    return event.exceptionDayType === a.id;
                                }
                            }}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.name}
                            value={dayTypes.find(x => x.id === event.exceptionDayType)}
                        />
                    </FormGroup>
                </div>
            );
        }

        return null;
    }

    render() {
        const { event, eventTypeInputError, nameInputError } = this.state;

        if (undefined === event || null === event) {
            return null;
        }

        const { title } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formEventType" validationState={eventTypeInputError}>
                            <ControlLabel>Tipo de Evento</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Tipos de Evento"
                                noOptionsMessage={() => "Sem Tipos de Evento Configurados"}
                                onChange={(e) => this.onSelectValueId(e, "type")}
                                options={SelectOptionsHelper.EventTypes}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== event.type && undefined !== event.type) {
                                        return event.type === a.id;
                                    }
                                }}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.label}
                                value={SelectOptionsHelper.EventTypes.find(x => x.id === event.type)}
                            />
                            {eventTypeInputError !== null ?
                                <HelpBlock> Tipo de Evento inválido </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formName" validationState={nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={event.name}
                                placeholder="Name"
                                onChange={(e) => this.onChangeValue(e, "name")} />

                            {nameInputError !== null ?
                                <HelpBlock> O campo não pode estar vazio </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        {this.renderUniqueEventForm(event)}
                        {this.renderRecurrentEventForm(event)}
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/calendar/events/EventForm.js